<template>
    <span>{{title}}
        <i class="fa fa-caret-down" v-if="filter.orderBy[0].orderBy === property && filter.orderBy[0].direction === 'desc'" aria-hidden="true"></i>
        <i class="fa fa-caret-up" v-if="filter.orderBy[0].orderBy === property && filter.orderBy[0].direction === 'asc'" aria-hidden="true"></i>
    </span>
</template>
<script>
export default {

  props: {
    title: String,
    property: String,
    filter: Object
  }

}
</script>

